var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ModalConfirm,{attrs:{"title":"이용권 변경","description":_setup.description},on:{"on-click-close":function($event){return _vm.$emit('click-close')},"on-click-submit":_setup.onClickSubmit},scopedSlots:_vm._u([{key:"confirm",fn:function(){return [_vm._v("변경")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }